import React from 'react';

import {AssignToRoleTool} from 'src/modules/bulk-update/update-admin-role/assign-to-role/assign-to-role.tool';
import {UnassignFromRoleTool} from 'src/modules/bulk-update/update-admin-role/unassign-from-role/unassign-from-role.tool';

import {FlatButton} from '@pb/kit-component-button';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import Icon, {Icons} from '@pb/kit-component-icon';
import {useShown} from '@pb/kit-hooks-use-shown';

type Props = {
    userIds: number[],
    onDone: () => void,
};

export const UpdateAdminRoleTool = ({userIds, onDone}: Props) => {
    const {
        shown: assignToRoleShown,
        onClose: closeAssignToRole,
        onClick: openAssignToRole,
    } = useShown();

    const {
        shown: unassignFromRoleShown,
        onClose: closeUnassignFromRole,
        onClick: openUnassignFromRole,
    } = useShown();

    return (
        <>
            <DropdownMenu
                anchor={({positionRef, getAnchorProps, anchorRef}) => (
                    <FlatButton
                        endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                        {...getAnchorProps()}
                        ref={anchorRef}>
                        <b>Set Admin Role</b>
                    </FlatButton>
                )}>
                <DropdownMenuItem
                    caption="Assign To Role"
                    onClick={openAssignToRole}
                />
                <DropdownMenuItem
                    caption="Unassign From Role"
                    onClick={openUnassignFromRole}
                />
            </DropdownMenu>
            <AssignToRoleTool {...{
                shown: assignToRoleShown,
                userIds,
                onDone,
                onClose: closeAssignToRole,
            }}
            />
            <UnassignFromRoleTool {...{
                shown: unassignFromRoleShown,
                userIds,
                onDone,
                onClose: closeUnassignFromRole,
            }}
            />
        </>
    );
};
